/*
Generated time: May 22, 2025 08:21
This file was created by the app developer. Feel free to contact the original developer with any questions. It was minified (compressed) by AVADA. AVADA do NOT own this script.
*/
function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    var t,
      o = document.body.clientWidth / 1080;
    $("#root").css("zoom", o),
      window.addEventListener("resize", function () {
        t && clearTimeout(t),
          (t = setTimeout(function () {
            $("#root").css("zoom", "normal");
            var t = document.body.clientWidth / 1080;
            $("#root").css("zoom", t);
          }, 100));
      }),
      (function t(o) {
        var e = parseInt(o / 1e3) % 86400,
          n = Math.floor(e / 3600),
          r = ((e %= 3600), Math.floor(e / 60)),
          e = e % 60,
          n = 1 == n.toString().length ? "0" + n : n,
          r = 1 == r.toString().length ? "0" + r : r,
          e = 1 == e.toString().length ? "0" + e : e;
        $(".sp_hour").html(n),
          $(".sp_minute").html(r),
          $(".sp_second").html(e),
          ("00" == n && "00" == r && parseInt(e) - 1 < 0) ||
            setTimeout(function () {
              t(o - 1e3);
            }, 1e3);
      })(
        1e3 *
          (3600 * (Math.floor(15 * Math.random()) + 1) +
            60 * Math.floor(60 * Math.random()) +
            Math.floor(60 * Math.random()))
      ),
      $("header").addClass("stiky"),
      $(document).scroll(function (t) {
        $(document).scrollTop();
        setTimeout(function () {
          $("header").addClass("stiky");
        }, 50);
      });
    $(".str3").liMarquee({ loop: -1, scrollamount: 100 });
    let e = window.product;
    alignmentFns.initialize(),
      $("#2").change(function () {
        var t = Number($("#2").val());
        $(this)
          .parents()
          .siblings(".sp-price")
          .children()
          .children(".new")
          .html(((t * Number(e[0].price)) / 100).toFixed(2)),
          $(this)
            .parents()
            .siblings(".sp-price")
            .children()
            .children(".old")
            .html(((t * Number(e[0].compare_at_price)) / 100).toFixed(2));
      }),
      $(".buyNow1").click(function () {
        var t = $(this).attr("data-id"),
          o = $(this).siblings(".sp-number").find("input").val();
        window.location.href = "/cart/" + t + ":" + o;
      }),
      $(".buyNow").click(function () {
        var t = $(this).attr("data-id");
        window.location.href = "/cart/" + t + ":1";
      });
  }),
    document.addEventListener("DOMContentLoaded", function () {
      {
        var t = document.querySelectorAll(".lazy-load");
        let e = new IntersectionObserver(
          function (t, o) {
            t.forEach(function (t) {
              var o;
              t.isIntersecting &&
                ((o = (t = t.target).getAttribute("data-src")),
                (t.src = o),
                e.unobserve(t));
            });
          },
          { rootMargin: "0px 0px 1300px 0px", threshold: 0 }
        );
        t.forEach(function (t) {
          e.observe(t);
        });
      }
      document.querySelectorAll('a[href^="#shopping"]').forEach(function (t) {
        t.addEventListener("click", function (t) {
          t.preventDefault();
          t =
            document.getElementById("shopping").offsetTop -
            $("header").height();
          window.scroll({
            top: t * $("div#root").css("zoom"),
            behavior: "smooth",
          });
        });
      });
    });
  var t = navigator.userAgent || navigator.vendor || window.opera,
    o = /android/i.test(t),
    e = /iPad|iPhone|iPod/.test(t) && !window.MSStream,
    t = !o && !e && !/Iron/.test(t);
  o
    ? console.log("Android")
    : e
    ? console.log("iOS")
    : t
    ? console.log("PC")
    : $(".sp_system").css("letter-spacing", "-4px");
}
mainRender();
